<template>
    <v-card flat >
      <v-card-title primary-title class="justify-center">
        <div class="pb-3 headline font-weight-medium ">{{$t('forgotPwRequest')}}</div>
      </v-card-title>
      <v-card-subtitle class="text-center pb-0"><span v-html="$t('forgotPwMessage')"></span></v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid">
            <v-col cols="12" > 
              <v-text-field 
              outlined 
              v-model="email"
              :disabled="app_loading"
              hide-details
              required
              :rules="emailRules"
              :label="$t('loginEmail')"
              @keydown.enter="requestToResetPasswort"
              placeholder="">
              </v-text-field> <!-- persistent-hint required -->
            </v-col>
            <div v-if="request_password_error" class="text-center red--text">{{$t('errorCodeEmailUnknown')}}</div>

            <!-- Navigation Buttons -->
            <v-row align="center" justify="center" class="ma-0 mt-3">
              <v-col cols="12" md="6" align="center"> 
                <v-btn large depressed block color="grey lighten-1" dark rounded  @click="close(false)" >{{$t('back')}}</v-btn>
              </v-col>
              <v-col cols="12" md="6" align="center">
                <v-btn large depressed block :color="theme.btnColorPrimary"  rounded  dark @click="requestToResetPasswort"  :loading="app_loading" >{{$t('ok')}}</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
</template>

<script>
  import {layoutMixin} from '@/utils/layout-mixin'
  import {settingsMixin} from '@/utils/settings-mixin'
  import {validationMixin} from '@/utils/validation-mixin'

  export default {
    mixins:[settingsMixin,validationMixin,layoutMixin],
    components:{

    },
    props:{
      enableRegister:{
        type:Boolean,
        default:true
      }
    },
    data: () => ({
      email:'',
      showPassword: false,
      login_error: false,
      valid: true,
      request_password_error:false
    }),
    computed:{
      hasValidEmail(){
        return !(null==this.email || this.email.trim()=='');
      }
    },
    methods:{

      close(withNotification=false){
        this.$emit('close',withNotification);
      },

      requestToResetPasswort(){
        if(this.hasValidEmail){
          this.request_password_error=false;
          this.requestPasswordChange(this.email).then(()=>{
            this.close(true);
          }).catch((ex) => {
            console.log(ex);
            console.log('Request password error');
            this.request_password_error=true;
          });
        }else{
          this.validate();
        }
      },

      validate () {
        this.$refs.form.validate()
      },
      
    },
    created(){
    }
  }
</script>
